<script>
import axios from "axios";
import { mapGetters } from "vuex";
import googleAnalyticsMixin from '@/mixins/googleAnalyticsMixin';

export default {
  name: 'SearchBuild',

  mixins: [
    googleAnalyticsMixin
  ],

  data() {
    return {
      buildNotFound: false,
      buildIsSearching: false,
      buildUid: '',
    }
  },

  computed: {
    ...mapGetters({
      isMagento: 'preference/isMagento',
    }),
  },

  methods: {
    async searchBuild() {
      this.buildIsSearching = true;
      this.buildNotFound = false;

      this.pushDataLayer({
        interaction_type: this.gaData.interactionTypes.next, //or 'submitBasicConfiguration', supplied GA document contradicts itself.
        build_id: this.buildUid,
        value: this.gaData.undefined,
        step: this.gaData.steps.step1,
        field: 'productcode samenstelling',
      })

      try {
        const {data} = await axios.post('search-build', {
          buildUid: this.buildUid,
        });

        await this.selectBuild(data.name);
      } catch (e) {
        this.buildNotFound = true;
      } finally {
        this.buildIsSearching = false;
      }
    },
    /**
     * @param {string} buildTypeName
     */
    async selectBuild(buildTypeName) {
      let routeName = null;

      switch (buildTypeName) {
        case 'powerpack':
          routeName = this.isMagento ? 'powerpack-generator' : 'powerpack-configurator';
          this.$router.push({
            name: routeName,
            query: {
              build: this.buildUid,
            }
          });
          break;
        case 'hose':
          routeName = 'slang-configurator';
          this.$router.push({
            name: routeName,
            query: {
              slang: this.buildUid,
            }
          });
          break;
        case 'motorconfig':
          routeName = 'motor-configurator';
          this.$router.push({
            name: routeName,
            query: {
              build: this.buildUid,
            }
          });
          break;
        default:
          throw new Error('Build not found');
      }

      this.$emit('close');
    },
  }
}
</script>

<template>
  <div class="search-build">
    <span>{{ $t('powerpack.steps.step1.build_code') }}</span>

    <div class="input-group flex-nowrap">
      <input
          type="text"
          v-model="buildUid"
          class="form-control"
          id="search-build"
          @focus="pushDataLayer({
            step: gaData.steps.step1,
            interaction_type: gaData.interactionTypes.click,
            field: 'productcode samenstelling',
            build_id: gaData.undefined,
            value: gaData.undefined,
          })"
      />
      <button
          class="btn btn-primary ml-1"
          :disabled="buildIsSearching"
          :class="{'disabled': buildIsSearching}"
          @click="searchBuild"
      >
        {{ $t('general.search') }}
      </button>
    </div>

    <small v-if="buildNotFound" class="text-danger">{{ $t('splash.build.notFound') }}</small>
  </div>
</template>

<style scoped lang="scss">
.search-build {

  input {
    max-width: 200px;
    border-radius: 50px !important;
    border: 2px solid #EBEBEB;

    &:focus {
      outline: none !important;
      box-shadow: none;
      border-color: #EBEBEB;
    }
  }

  .title {
    font-size: 20px;
  }

  .btn {
    padding: 5px 30px !important;
  }
}
</style>
